import SplitType from 'split-type';

export class TextSplitter {
    constructor(textElement, options = {}) {
        if (!textElement || !(textElement instanceof HTMLElement)) {
            throw new Error('Invalid text element provided.');
        }
        this.textElement = textElement;
        this.options = options;
        this.resizeCallback = options.resizeCallback || null;

        // Initialize SplitType
        this.splitType = new SplitType(this.textElement, {
            types: options.splitTypeTypes || 'words, chars'
        });

        // Handle resize if callback provided
        if (this.resizeCallback) {
            window.addEventListener('resize', this.resizeCallback);
        }
    }

    getChars() {
        return this.splitType.chars;
    }

    getWords() {
        return this.splitType.words;
    }

    revert() {
        this.splitType.revert();
    }
}
